module.exports = __webpack_public_path__ + "images/6d953398.gif";